import api from "./api";

export interface MoMChange {
  change: string;
  up: boolean;
}

export interface AnalyticsKPIs {
  totalViews: number;
  totalLeads: number;
  leadRate: string;
  activeListings: number;
  totalListings: number;
  viewsChange?: MoMChange;
  leadsChange?: MoMChange;
  rateChange?: MoMChange;
  avgResponseTime?: {
    value: string;
    change: string;
    up: boolean;
  };
}

export interface MonthlyAnalytics {
  month: string;
  leads: number;
  views: number;
}

export interface ListingPerformance {
  id: string;
  name: string;
  views: number;
  leads: number;
}

export interface TrafficSource {
  name: string;
  value: number;
  color: string;
}

export interface SellerAnalyticsData {
  kpis: AnalyticsKPIs;
  monthly: MonthlyAnalytics[];
  listingPerformance: ListingPerformance[];
  trafficSources: TrafficSource[];
}

export interface AnalyticsResponse {
  success: boolean;
  data: SellerAnalyticsData;
}

export const analyticsService = {
  getSellerAnalytics: async (): Promise<AnalyticsResponse> => {
    const response = await api.get<AnalyticsResponse>("/analytics");
    return response.data;
  },
};

export default analyticsService;
